<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('default.edit_company')}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <v-wait for="edit">

              <loading slot="waiting"/>

              <form @submit.prevent="validate_edit">


                <div class="form-group">

                  <label for="name">{{ $t('simple.company_name') }}</label>

                  <input
                      class="form-control"
                      type="text"
                      id="name"
                      name="name"
                      v-validate="'required|max:50'"
                      v-model="name"
                  >

                  <small v-show="errors.has('name')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('name') }}</small>
                  <small v-if="serverErrors.name" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ serverErrors.name[0] }}</small>
                </div>


                <div class="form-group">

                  <label for="phone">{{ $t('simple.super_admin_phone') }}</label>

                  <input
                      class="form-control"
                      type="text"
                      id="phone"
                      name="phone"
                      v-validate="'required|numeric|length:12'"
                      v-model="phone"
                  >

                  <small v-show="errors.has('phone')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('phone') }}</small>
                  <small v-if="serverErrors.phone" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ serverErrors.phone[0] }}</small>
                </div>
                <div class="form-group">

                  <label for="email">{{ $t('simple.super_admin_email') }}</label>

                  <input
                      class="form-control"
                      type="text"
                      id="email"
                      name="email"
                      v-validate="'required|email|max:255'"
                      v-model="email"
                  >

                  <small v-show="errors.has('email')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('email') }}</small>
                  <small v-if="serverErrors.email" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ serverErrors.email[0] }}</small>
                </div>
                <div class="form-group">

                  <label for="password">{{ $t('simple.super_admin_password') }}</label>

                  <input
                      class="form-control"
                      type="password"
                      id="password"
                      name="password"
                      v-validate="'min:8'"
                      v-model="password"
                  >

                  <small v-show="errors.has('password')" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ errors.first('password') }}</small>
                  <small v-if="serverErrors.password" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ serverErrors.password[0] }}</small>
                </div>
                <div class="form-group">

                  <label for="confirmation">{{ $t('simple.company_status') }}:</label>

                  <b-form-checkbox v-model="status" switch
                                   :value="1"
                                   :unchecked-value="0">
                    {{ check_status() }}
                  </b-form-checkbox>

                  <span></span>
                </div>
                <div v-if="!status" class="mt-2">
                  <label for="status_reason">{{ $t('simple.company_status_reason') }}</label>
                  <textarea
                      id="status_reason"
                      class="form-control"
                      v-model="status_reason"
                      v-validate="'required'"
                      name="status_reason"
                  ></textarea>
                  <small v-show="errors.has('status_reason')" class="form-text text-danger">
                    <font-awesome-icon :icon="'times-circle'" /> {{ errors.first('status_reason') }}
                  </small>
                  <small v-if="serverErrors.status_reason" class="form-text text-danger"><font-awesome-icon :icon="'times-circle'" /> {{ serverErrors.status_reason[0] }}</small>
                </div>
                <div class="form-group">
                  <label for="deactive">{{ $t('simple.auto_deactivation') }}:</label>
                  <b-row>
                    <b-col class="d-inline-flex">
                      <b-btn variant="light" @click.prevent="schedule"
                             class="deactive-select-btn">
                        <div>
                          <font-awesome-icon :icon="'clock'" :class="'plus__icon'" />
                          {{ schedule_date ? formatDate(schedule_date) : $t('simple.select_time') }}
                        </div>
                      </b-btn>
                      <b-btn
                          @click.prevent="schedule_date = ''"
                          class="deactive-remove-btn"
                          v-if="schedule_date"
                          variant="danger">
                        <font-awesome-icon :icon="'times'" :class="'text-white'" style="cursor: pointer"/>
                      </b-btn>
                    </b-col>
                    <datetime ref="datepicker" type="datetime" v-model="schedule_date"
                              :min-datetime="start_date" format="yyyy-MM-dd HH:mm"
                              input-class="btn btn-outline-dark"
                              input-style="width : 140px; display: none;" class="theme-message">
                    </datetime>
                  </b-row>
                </div>
              </form>

            </v-wait>

        </div>

        <div class="modal-footer">

            <b-button @click="$close(false)" variant="secondary">{{ $t('simple.cancel') }}</b-button>
            <div v-b-tooltip.hover.right="{
                 title:!user_permissions.includes('update-companies')? $t('permission.permission_denied', { permission: 'update-companies' }) : '',customClass: 'tooltip-dark' }"
                 style="display: inline-block">
              <b-button @click="validate_edit()" variant="primary" :class="!user_permissions.includes('update-companies') ? 'cursor-not-allowed' : ''"
                        :disabled="!user_permissions.includes('update-companies')">{{ $t('simple.save') }}</b-button>
            </div>
        </div>


        </div>
      </div>
    </div>
</template>
<script>

    import {mapGetters} from "vuex";
    import {DateTime} from "luxon";

    export default {

        mounted: function () {
            // Component mounted
            console.log('Company Edit Modal mounted');

            // Get data to edit
            this.edit(this.id);
        },

        destroyed() {
            console.log('Company Edit Modal destroyed.');
        },

        data: function() {
             return  {
                companies_api: '/api/v1/settings/companies/',
                name: '',
                status: 1,
                status_reason: '',
                email: '',
                password: '',
                phone: '',
                user_id: '',
                serverErrors: {},
                schedule_date: '',
                start_date: DateTime.local().plus({ minutes: 1 }).toISO(),
            }
        },

        methods: {
          formatDate(date) {
            if (!date){
              return ''
            }
            return DateTime.fromISO(date).toFormat("yyyy-MM-dd HH:mm:ss");
          },
          schedule() {
            const datePicker = this.$refs.datepicker;
            datePicker.isOpen = true;
          },
          check_status: function() {
            if(this.status === 1){
              return this.$t('default.enabled');
            } else {
              return this.$t('default.disabled');
            }
          },
            edit: async function(id) {

                // Loading start
                this.$wait.start('edit');

                // Get tags
                await axios.get(this.companies_api + id)
                    .then((response) => {

                        // Update modal data
                        this.name = response.data.company.name;
                        this.status  = response.data.company.status;
                        this.schedule_date = DateTime.fromSQL(response.data.company.deactivate_at, { zone: 'utc' }).toLocal().toISO();
                        this.status_reason  = response.data.company.status_reason;
                        this.phone  = response.data.user.phone;
                        this.email  = response.data.user.email;
                        this.user_id  = response.data.user.id;
                        // Loading stop
                        this.$wait.end('edit');

                    })
                    .catch((error) => {
                      // Show error
                        Vue.toasted.error(this.$t('simple.error_info'));
                        // Loading stop
                        this.$wait.end('edit');

                        // Close modal
                        this.$close(true);

                    });

            },

            company_edit: async function(){

                // Loading start
                this.$wait.start('edit');

                await axios.put(this.companies_api + this.id, {
                  name: this.name,
                  status: this.status,
                  status_reason: this.status_reason,
                  email: this.email,
                  password: this.password,
                  phone : this.phone,
                  user_id : this.user_id,
                  deactivate_at : this.schedule_date ? DateTime.fromISO(this.schedule_date).toUTC().toFormat("yyyy-MM-dd HH:mm:ss") : ''
                  })
                  .then((response) => {

                    // Show success
                    Vue.toasted.success(this.$t('simple.success_info'));

                    // Loading stop
                    this.$wait.end('edit');

                    // Close modal
                    this.$close(true);


                  })
                  .catch((error) => {

                    // Show error
                    if (error.response && error.response.status === 403) {
                      Vue.toasted.error(this.$t('permission.permission_denied',{ permission: 'update-companies'}));
                    } else if (error.response && error.response.status === 422) {
                      this.serverErrors = error.response.data.errors;
                    }
                    else {
                      Vue.toasted.error(this.$t('simple.error_info'));
                    }
                    // Loading stop
                    this.$wait.end('edit');

                    // Close modal
                    //this.$close(true);

                  });

            },

            validate_edit: async function() {
                // validate all fields
                await this.$validator.validateAll().then((result) => {
                    if (result) {
                        // Send it to account edit function
                        this.company_edit();
                    }
                });
            },
        },
      computed: {
        // Map getters
        ...mapGetters({
          user_permissions: 'User/getUserPermissions'
        })
      },
    }
</script>